import Router from './Router';
import './App.css';
import {ToastProvider} from "react-toast-notifications";
import DepotsProvider from "./context/Depots/DepotsProvider";
import RequestInterceptor from "./components/RequestInterceptor/RequestInterceptor";
import {ThemeProvider} from "@mui/styles";
import {createTheme} from "@mui/material";
import {frFR} from "@mui/x-data-grid";
import {frFR as coreFrFR} from '@mui/material/locale';

const theme = createTheme(frFR, coreFrFR)

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <ToastProvider autoDismiss>
                <RequestInterceptor>
                    <DepotsProvider>
                        <Router/>
                    </DepotsProvider>
                </RequestInterceptor>
            </ToastProvider>
        </ThemeProvider>
    )
}
